import React from 'react';
import { Edit } from 'react-admin';
import { parse } from 'query-string';
import PortfolioForm from './PortfolioForm';
import BackButton from 'components/BackButton';

const PortfolioEdit = (props: any) => {
  const { consultantskillset } = parse(props.location.search);
  const redirect = `/consultantskillsets/${consultantskillset}/3`;

  return (
    <Edit {...props} actions={<BackButton goTo={redirect} />} undoable={false}>
      <PortfolioForm redirect={redirect} location={props.location} />
    </Edit>
  );
};

export default PortfolioEdit;
